// Element types
export const HTML_ELEMENT = 1;
export const CLASS_COMPONENT = 2;
export const FUNCTION_COMPONENT = 3;
export const FORWARD_REF = 4;
export const MEMO = 5;
export const SUSPENSE = 6;

// Devtools Event Messages
export const ADD_ROOT = 1;
export const ADD_VNODE = 2;
export const REMOVE_VNODE = 3;
export const UPDATE_VNODE_TIMINGS = 4;
export const REORDER_CHILDREN = 5;
